module.exports = __webpack_public_path__ + "static/media/kidslogo.a044d4c1.png";